import { render, staticRenderFns } from "./HospitalIntroNfykdx7.vue?vue&type=template&id=4a2096f6&scoped=true"
import script from "./HospitalIntroNfykdx7.vue?vue&type=script&lang=js"
export * from "./HospitalIntroNfykdx7.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroNfykdx7.vue?vue&type=style&index=0&id=4a2096f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2096f6",
  null
  
)

export default component.exports